import State from "/WebInterface/new-ui/store/state.js";
import uploadingQueue from "/WebInterface/new-ui/upload/js/uploading-queue.js";

// Define the initial state of the store
const initialState = {
  fileList: {},
  customCommonUploadFormValues: null,
};

// Create a new instance of the State class with initial state and empty actions, subscriptions, and history
const store = new State({ actions: {}, subscriptions: [], history: [] });

// Initialize the store with the initial state
Object.keys(initialState).forEach((key) => {
  if (!(key in store)) {
    store[key] = initialState[key];
  }
});

store.addFileToUploadFileList = (data = { payload: {} }) => {
  const files = data.payload;
  store.fileList = { ...store.fileList, ...files };
};

store.addFileToUploadFileListAndRefresh = (data = { payload: {} }) => {
  const files = data.payload;
  store.fileList = { ...files };
};

store.updateFileStatusAndRerenderFile = (data = { payload: {} }) => {
  const files = data.payload;
  const updatedFiles = {};

  Object.keys(files).forEach((fileId) => {
    const existingFile = store.fileList[fileId];
    const newFile = files[fileId];

    if (existingFile) {
      updatedFiles[fileId] = {
        ...existingFile,
        ...newFile,
        uploadedBytes:
          newFile.uploadedBytes !== undefined
            ? newFile.uploadedBytes
            : existingFile.uploadedBytes,
      };
    } else {
      updatedFiles[fileId] = newFile;
    }
  });

  store.fileList = { ...store.fileList, ...updatedFiles };
};

store.updateFileStatus = (data = { payload: {} }) => {
  const files = data.payload;
  store.fileList = { ...store.fileList, ...files };
};

store.updateFileStatusInFileList = (data = { payload: {} }) => {
  const files = data.payload;
  store.fileList = { ...store.fileList, ...files };
};

store.removeFileFromUploadFileListing = (data = { payload: {} }) => {
  const { id } = data.payload;
  delete store.fileList[id];
};

store.removeMultipleFilesFromUploadFileListing = (data = { payload: {} }) => {
  const { status } = data.payload;
  const fileList = Object.values(store.fileList);

  const currentUploadingQueue = uploadingQueue.getQueue();

  const getStatus = (file) =>
    status === "listingError"
      ? file.status === status || file.status === "restrictionError"
      : file.status === status;

  fileList.forEach((file) => {
    const fileInUploadingQueue = currentUploadingQueue.find(
      (f) => f?.id === file?.id
    );

    if (fileInUploadingQueue) {
      return;
    }

    if (!status || getStatus(file) || file[status] === true) {
      delete store.fileList[file.id];
    }
  });
};

store.updateFileUploadStatus = (data = { payload: {} }) => {
  const { fileId, size, maxSize } = data.payload;
  const existingFile = store.fileList[fileId];

  // Preserve the file size and ensure uploadedBytes is never less than the actual file size
  const actualSize = existingFile?.size || maxSize;
  const uploadedBytes = size || actualSize;

  store.fileList[fileId] = {
    ...existingFile,
    uploadedBytes: uploadedBytes,
    size: actualSize, // Ensure file size is preserved
  };
};

store.updateFileTimeStatus = (data = { payload: {} }) => {
  const { fileId } = data.payload;

  const payload = { ...data.payload };
  delete payload.fileId;

  store.fileList[fileId] = { ...store.fileList[fileId], ...payload };
};

store.toggleChunkPreparationStalled = (data = { payload: {} }) => {
  const { fileId } = data.payload;

  const payload = { ...data.payload };
  delete payload.fileId;
  if (store.fileList[fileId]) {
    store.fileList[fileId] = { ...store.fileList[fileId], ...payload };
  } else {
    debugger; //eslint-disable-line
  }
};

store.setCustomCommonUploadFormValues = (data = { payload: {} }) => {
  store.customCommonUploadFormValues = data.payload;
  console.log(store);
};

export default store;
